(function(){
  if (window.__fmHeaderMobileAlignmentInit) return;
  window.__fmHeaderMobileAlignmentInit = true;

  function resetLogo(){
    var logo=document.querySelector('.site-header-main .site-header-logo');
    if(!logo) return;
    logo.style.removeProperty('position');
    logo.style.removeProperty('left');
    logo.style.removeProperty('top');
    logo.style.removeProperty('transform');
  }

  function scheduleReset(){
    window.requestAnimationFrame(resetLogo);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',scheduleReset,{once:true});
  }else{
    scheduleReset();
  }

  window.addEventListener('resize',scheduleReset,{passive:true});
  document.addEventListener('shopify:section:load',scheduleReset);
})();